// 切换env取值  dev/prod
const ENV = 'dev'; // 默认测试

const url = window.location.host.split('.').slice(-2).join('.');

const hostEnv = {
	dev: 'https://dev.clpdf.com',
	prod: 'https://www.clpdf.com',
};

const apis = {
	dev: 'https://dev-api.clpdf.com',
	prod: 'https://api.clpdf.com',
};

// console.log(process);
const global = {
	baseUrl: apis[ENV],
	baseHost: hostEnv[ENV],

	device_id: parseParameters('device_id'),
	os: 'windows',
	os_ver: '163842', // 系统版本号,
	version: parseParameters('version') || '',
	token: parseParameters('token') || store.get('sessionId'),
	lenovoToken: parseParameters('lenovoToken') || '',
	qd: parseParameters('qd') || 'home',
	product: parseParameters('product') || 'clpdf',
};

global.appParm = {
	product: global.product,
	version: global.version,
	device_id: global.device_id,
	os: global.os,
	qd: global.qd,
	os_ver: global.os_ver,
	// country_code: parseParameters('country_code') || '',
};

// 获取地址栏参数
function getQueryUrl(data) {
	let url = data || window.location.href;
	let result = {};
	if (url.indexOf('?') > -1) {
		let str = url.split('?')[1];
		let temp = str.split('&');
		for (let i = 0; i < temp.length; i++) {
			let temp2 = temp[i].split('=');
			result[temp2[0]] = temp2[1];
		}
	}

	return result;
}

function parseParameters(name) {
	const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	const r = window.location.search.substr(1).match(reg);
	if (r != null) {
		if (r[2].indexOf('%') > -1) {
			return decodeURI(r[2].replace(/%/g, '%25'));
		} else {
			return decodeURI(r[2]);
		}
	} else {
		return null;
	}
}

function getQueryString(search, paramName) {
	let paramValue = '';
	let isFound = !1;
	let arrSource;
	let i;
	if (search.indexOf('?') === 0 && search.indexOf('=') > 1) {
		(arrSource = unescape(search).substring(1, search.length).split('&')),
			(i = 0);
		while (i < arrSource.length && !isFound)
			arrSource[i].indexOf('=') > 0 &&
				arrSource[i].split('=')[0].toLowerCase() === paramName.toLowerCase() &&
				((paramValue = arrSource[i].split('=')[1]), (isFound = !0)),
				i++;
	}
	return paramValue == '' && (paramValue = null), paramValue;
}

try {
	let strExecuteId5 = apiFromPc('getProduct', getProductCallback);
} catch (e) {
	// console.log(e);
}
function getProductCallback(strExecuteId, strErrorCode, strResult) {
	if (!Number(strErrorCode)) {
		global.product = strResult;
	} else {
		setTimeout(function () {
			let strExecuteId5 = apiFromPc('getProduct', getProductCallback);
		}, 10000);
	}
}

if (!global.qd || !reg.qdRegexString.test(parseParameters('qd'))) {
	global.qd = 'default';
} else if (global.qd.length > 20) {
	global.qd = 'home';
}

function goPage(path, parm) {
	setTimeout(function () {
		var urlParm = {};
		$.extend(urlParm, global.appParm, parm);
		openWindow(path, urlParm);
	}, 0);
}

function openWindow(path, parm) {
	var page = path;
	var newParm = {};
	if (page === 'payment') {
		$.extend(newParm, parm, { pagewidth: 668, pageheight: 545 });
	}
	if (page === 'vip-privilege') {
		$.extend(newParm, parm, { pagewidth: 628, pageheight: 592 });
	}
	if (page === 'login') {
		$.extend(newParm, parm, { pagewidth: 576, pageheight: 470 });
	}
	if (page === 'login_pic') {
		$.extend(newParm, parm);
	}
	if (page === 'bind-phone') {
		$.extend(newParm, parm, { pagewidth: 576, pageheight: 470 });
	}
	if (page === 'reset') {
		$.extend(newParm, parm, { pagewidth: 576, pageheight: 470 });
	}
	if (page === 'register') {
		$.extend(newParm, parm, { pagewidth: 576, pageheight: 470 });
	}

	if (page === 'usercenter') {
		$.extend(newParm, parm, { pagewidth: 1000, pageheight: 1000 });
	}

	if (page === 'protocol') {
		window.open('/' + path, '_blank');
	} else {
		location.href = '/' + path + '?' + $.param(newParm);
	}
}

function toMD5ToBase64(text) {
	text = CryptoJS.MD5(text).toString();
	text = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
	return text;
}

// 格式化日期时间
function formatDate(t) {
	var time = new Date(t * 1000);
	var year = time.getFullYear();
	var month = time.getMonth() + 1;
	var date = time.getDate();
	var hours = time.getHours();
	var minutes = time.getMinutes();
	var seconds = time.getSeconds();
	return (
		year +
		'.' +
		singleFormat(month) +
		'.' +
		singleFormat(date) +
		'-' +
		singleFormat(hours) +
		':' +
		singleFormat(minutes) +
		':' +
		singleFormat(seconds)
	);
}

function singleFormat(n) {
	if (Number(n) < 10) {
		return '0' + String(n);
	}
	return n;
}

/**按ascii码从小到大排序
 *
 * @param obj
 * @returns {string}
 */
function sort_ascii(obj, body) {
	var arr = new Array();
	var num = 0;
	for (let i in obj) {
		arr[num] = i;
		num++;
	}
	var sortArr = arr.sort();
	var sortObj = {}; //完成排序值
	for (let i in sortArr) {
		sortObj[sortArr[i]] = obj[sortArr[i]];
	}

	var str = '';
	console.log('sortObj: ', sortObj);

	for (let key in sortObj) {
		str += key + sortObj[key];
	}

	var secret = '3dzX0N8snDNbjJVVSd7TDh8NYpWcaNoY';
	str = secret + str2utf8(str + JSON.stringify(body)) + secret;
	str = CryptoJS.MD5(str).toString();

	return str;
}

// 字符串转 utf-8
var str2utf8 = window.TextEncoder
	? function (str) {
			var encoder = new TextEncoder('utf8');
			var bytes = encoder.encode(str);
			var result = '';
			for (var i = 0; i < bytes.length; ++i) {
				result += String.fromCharCode(bytes[i]);
			}
			return result;
	  }
	: function (str) {
			return eval("'" + encodeURI(str).replace(/%/gm, '\\x') + "'");
	  };

// type: string			info  error  success
// msg: string
const message = (msg) => {
	if (!msg) {
		return;
	}
	const wrap = document.createElement('div');
	wrap.innerHTML = msg;
	wrap.setAttribute('class', 'message-wrap');
	wrap.setAttribute('id', 'message-wrap');
	document.body.appendChild(wrap);

	const timer = setTimeout(function () {
		$('#message-wrap').hide();
		clearTimeout(timer);
	}, 3000);
};

const apiFromPc = (fucName, callback, ...param) => {
	try {
		const key = parseParameters('webview');
		if (key === 'edge') {
			const params = Object.assign({}, param);
			const res =
				chrome.webview &&
				chrome.webview.hostObjects.sync.asexternal.Execute(
					fucName,
					JSON.stringify(params)
				);

			if (res) {
				const data = JSON.parse(res);
				if (data && data.r1) {
					callback('', '', data.r1);
				}
			}
		} else {
			external.Execute && external.Execute(fucName, callback, ...param);
		}
	} catch (error) {
		console.log('apiFromPc: ', error.toString());
	}
};

// 打点
function funcDoReport() {
	var params = {
		sign_method: 'md5',
		timestamp: Math.round(new Date().getTime() / 10000),
	};

	$.ajax({
		type: 'POST',
		url: `${ApiEnv.doReport}?timestamp=${params.timestamp}&sign=${sort_ascii(
			params,
			reportParm,
			true
		)}&sign_method=md5`,
		data: reportParm,
		success: function (res) {
			console.log(res);
		},
	});
}

var reportParm = {
	action: 'show_pay_wnd',
	product: parseParameters('product'),
	device_id: parseParameters('device_id'),
	qd: parseParameters('qd'),
	os: parseParameters('os_ver') || '163842',
	day: formatDate(new Date().getTime()),
	status: 'none',
	version: parseParameters('version') || '1.9.9.9',
};
